import { useForm } from 'react-hook-form-mui';

import { useResolveFileResolution } from 'src/use-cases/internalDashboard/useFileResolution';
import { ROW_ACTION_TYPE, TUpdateValues } from './types';
import { ModalUpdateBase } from './ModalUpdateBase';
import { FormResolve } from './FormResolve';
import { useInternalDashboardSelector } from './Selector';

const defaultValues = {
  status: '',
  message: '',
};

export const ModalResolve = () => {
  const { selectedRow, setIsActionLoading, stopRowAction } = useInternalDashboardSelector();
  const { mutateAsync: resolve } = useResolveFileResolution();

  const formContext = useForm({
    defaultValues: defaultValues as TUpdateValues,
  });

  const onSubmitForm = async (values: TUpdateValues) => {
    setIsActionLoading(true);

    const updatesData = {
      id: selectedRow?.id,
      data: {
        status: values?.status || '',
        message: values?.message || '',
        resolutionType: selectedRow?.resolutionType,
      },
      params: undefined,
    };

    await resolve(updatesData);

    setIsActionLoading(false);
    stopRowAction();
  };

  return (
    <ModalUpdateBase title='Resolve' actionType={ROW_ACTION_TYPE.RESOLVE} formContext={formContext} onSubmit={onSubmitForm}>
      <>
        <p className='text-16 text-blue_grey-80'>Assign the Resolution Status and provide the resolution details:</p>
        <div className='mt-20'>
          <FormResolve />
        </div>
      </>
    </ModalUpdateBase>
  );
};
